import get from 'lodash.get';
import { config } from '@yola/ws-sdk';
import getIsB2C from './is-b2c';

const getAnalyticsUrl = (rootState) => {
  const cfg = config.selectors.getConfig(rootState);
  if (getIsB2C(rootState)) {
    return get(cfg, 'common.analytics.url');
  }

  return get(cfg, 'common.analytics.wl_url');
};

export default getAnalyticsUrl;
